module.exports = __webpack_public_path__ + "img/health.8597bd07.png";